import React from "react";
import { Icon, Version } from "../../../components";
import { Grid, Row, Col } from "../../../components/Grid";
import { StyledFooter } from "./style";
import { useTheme } from "styled-components";

const Footer = () => {
  const theme = useTheme();
  return (
    <Grid fluid w100>
      <Row>
        <Col>
          <StyledFooter>
            <Icon icon="new_white_brand" color={theme.colors.red} />
            <Version />
          </StyledFooter>
        </Col>
      </Row>
    </Grid>
  );
};

export default Footer;
